import { Span } from '@latitude/text';

export default Span;
